import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('authChecker');

    return {
        API_ERROR: t('apiError'),
        ORGANIZATION: t('organization')
    };
};

export default useTranslation;
